/** Franchise kiosk device password: 4 letters + 4 numbers (e.g. abcd1234). */
export const DEVICE_PASSWORD_RE = /^[A-Za-z]{4}\d{4}$/;

export function isValidDevicePassword(value) {
  return DEVICE_PASSWORD_RE.test(String(value || '').trim());
}

export const DEVICE_PASSWORD_HINT =
  'Use exactly 8 characters: 4 letters then 4 numbers (e.g. abcd1234).';
